import  { getErrorConfig } from "./errorConfig";

export const mapErrorToConfig = (code, t) => {  
  return getErrorConfig(code, t);
};
